import { NavLink } from "react-router-dom";
import { Map, PlusCircle, ListChecks, ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const BottomNav = () => {
  const { user } = useAuth();
  const items = [
    { to: "/", label: "Mappa", icon: Map, id: "nav-map" },
    { to: "/segnala", label: "Libero il posto", icon: PlusCircle, id: "nav-signal" },
    { to: "/attivita", label: "Le mie attività", icon: ListChecks, id: "nav-activity" },
  ];
  if (user?.role === "admin") items.push({ to: "/admin", label: "Admin", icon: ShieldCheck, id: "nav-admin" });

  return (
    <nav className="fixed bottom-3 left-1/2 -translate-x-1/2 z-[1000] w-[calc(100%-1.5rem)] max-w-xl rounded-2xl bg-stone-900/80 backdrop-blur-xl border border-stone-700/60 shadow-2xl">
      <ul className="flex">
        {items.map(({ to, label, icon: Icon, id }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end
              data-testid={id}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-2.5 text-[11px] font-semibold transition-colors ${
                  isActive ? "text-amber-400" : "text-stone-400 hover:text-stone-100"
                }`
              }
            >
              <Icon className="h-5 w-5" />
              <span className="truncate max-w-full px-1">{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
